import React from "react";
import { resolveImg } from "../../../../lib/api";
import { inp, lbl } from "../../shared";

const Section = ({ children }) => <div className="pt-6 border-t border-[#262421]">{children}</div>;

const updateAt = (list, i, patch) => list.map((x, idx) => (idx === i ? { ...x, ...patch } : x));

export const ShippingRates = ({ settings, patch }) => {
  const r = settings.shipping_rates || { uae_zones: [], gcc: { land: {}, air: {} } };
  const set = (p) => patch("shipping_rates", { ...r, ...p });
  const num = (v) => (v === "" ? "" : parseFloat(v));
  return (
    <div className="space-y-6" data-testid="ship-rates">
      <div className="border border-[#262421] p-4">
        <p className="text-xs uppercase tracking-[0.15em] text-[#C49A6C] mb-3">داخل الإمارات · UAE (per area)</p>
        <label className={lbl}>شركة التوصيل · Courier</label>
        <input value={r.uae_courier || ""} onChange={(e) => set({ uae_courier: e.target.value })} data-testid="ship-uae-courier" className={inp} />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2 mt-4">
          {r.uae_zones.map((z, i) => (
            <label key={z.key} className="block border border-[#1E1C19] px-3 py-2">
              <span className="block text-sm text-[#F2EBE1] truncate">{z.ar}</span>
              <span className="block text-[11px] text-[#8A857D] truncate">{z.en}</span>
              <input type="number" min="0" value={z.price} onChange={(e) => set({ uae_zones: updateAt(r.uae_zones, i, { price: num(e.target.value) }) })} data-testid={`ship-zone-${z.key}`} className={inp + " mt-2"} />
            </label>
          ))}
        </div>
      </div>
      <div className="border border-[#262421] p-4">
        <label className={lbl}>شحن مجاني للطلبات من (درهم) · Free shipping from (AED) — 0 = off</label>
        <input type="number" min="0" value={settings.free_shipping_threshold ?? 0} onChange={(e) => patch("free_shipping_threshold", num(e.target.value))} data-testid="ship-free-threshold" className={inp} />
      </div>
      <div className="border border-[#262421] p-4">
        <p className="text-xs uppercase tracking-[0.15em] text-[#C49A6C] mb-3">دول الخليج · GCC (AED, by weight)</p>
        <div className="grid sm:grid-cols-2 gap-4">
          <div><label className={lbl}>شركة الشحن · Courier</label><input value={r.gcc_courier || ""} onChange={(e) => set({ gcc_courier: e.target.value })} data-testid="ship-gcc-courier" className={inp} /></div>
          <div><label className={lbl}>وزن العطر مع التغليف (كغ) · Weight per bottle (kg)</label><input type="number" step="0.05" min="0.05" value={r.unit_weight_kg ?? ""} onChange={(e) => set({ unit_weight_kg: num(e.target.value) })} data-testid="ship-unit-weight" className={inp} /></div>
          {["land", "air"].map((m) => (
            <div key={m} className="grid grid-cols-2 gap-3 sm:col-span-2">
              <div><label className={lbl}>{m === "land" ? "بري" : "جوي"} · {m} — أول كيلو · first kg</label>
                <input type="number" min="0" value={r.gcc?.[m]?.first ?? ""} onChange={(e) => set({ gcc: { ...r.gcc, [m]: { ...r.gcc[m], first: num(e.target.value) } } })} data-testid={`ship-${m}-first`} className={inp} /></div>
              <div><label className={lbl}>كيلو إضافي · each extra kg</label>
                <input type="number" min="0" value={r.gcc?.[m]?.extra ?? ""} onChange={(e) => set({ gcc: { ...r.gcc, [m]: { ...r.gcc[m], extra: num(e.target.value) } } })} data-testid={`ship-${m}-extra`} className={inp} /></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export const CurrencyRates = ({ settings, patch }) => (
  <Section>
    <p className="text-xs uppercase tracking-[0.15em] text-[#C49A6C] mb-4">أسعار صرف العملات (مقابل الدرهم) · Currency rates (per 1 AED)</p>
    {["SAR", "USD"].map((cur) => (
      <div key={cur} className="flex items-center justify-between gap-4 mb-3">
        <span className="text-sm">1 AED → {cur}</span>
        <input type="number" step="0.0001" value={settings.currency_rates?.[cur] ?? ""} data-testid={`rate-${cur}`} className={inp + " w-32"}
          onChange={(e) => patch("currency_rates", { ...(settings.currency_rates || {}), AED: 1, [cur]: parseFloat(e.target.value) || 0 })} />
      </div>
    ))}
  </Section>
);

export const ContactFields = ({ settings, patch }) => (
  <>
    <Section><label className={lbl}>Instagram URL</label><input value={settings.instagram_url || ""} onChange={(e) => patch("instagram_url", e.target.value)} className={inp} /></Section>
    <div><label className={lbl}>Contact Email</label><input value={settings.email || ""} onChange={(e) => patch("email", e.target.value)} className={inp} /></div>
  </>
);

export const SalesWindow = ({ settings, patch }) => (
  <Section>
    <label className="flex items-center gap-3 cursor-pointer">
      <input type="checkbox" checked={settings.sales_open !== false} onChange={(e) => patch("sales_open", e.target.checked)} data-testid="sales-open-toggle" className="w-4 h-4 accent-[#C49A6C]" />
      <span className={lbl + " !mb-0"}>فتح الشراء · Store open for purchase</span>
    </label>
    <div className="grid sm:grid-cols-2 gap-4 mt-4">
      <div><label className={lbl}>من تاريخ · Open from</label><input type="date" value={settings.sales_start || ""} onChange={(e) => patch("sales_start", e.target.value)} data-testid="sales-start" className={inp} /></div>
      <div><label className={lbl}>إلى تاريخ · Close after</label><input type="date" value={settings.sales_end || ""} onChange={(e) => patch("sales_end", e.target.value)} data-testid="sales-end" className={inp} /></div>
    </div>
    <p className="text-[10px] text-[#6E685F] mt-2">اترك التواريخ فارغة للتحكم اليدوي بالزر · Leave dates empty to control manually with the toggle.</p>
  </Section>
);

export const LogoField = ({ settings, patch, uploading, onUpload }) => (
  <Section>
    <label className={lbl}>Header Logo (white PNG works best on dark header)</label>
    <div className="flex items-center gap-4 mt-2">
      <div className="w-32 h-16 bg-[#151515] border border-[#262421] flex items-center justify-center overflow-hidden">
        {settings.logo_url ? <img src={resolveImg(settings.logo_url)} alt="logo" className="max-h-14 max-w-28 object-contain" /> : <span className="text-[10px] text-[#6E685F]">No logo</span>}
      </div>
      <label className="cursor-pointer border border-[#262421] px-4 py-2 text-xs uppercase tracking-widest hover:border-[#C49A6C] transition-colors" data-testid="logo-upload">
        {uploading ? "…" : "Upload"}
        <input type="file" accept="image/*" className="hidden" onChange={onUpload} />
      </label>
      {settings.logo_url && <button onClick={() => patch("logo_url", "")} className="text-[#6E685F] hover:text-[#c88] text-xs uppercase tracking-widest">Remove</button>}
    </div>
  </Section>
);
